module.exports = __webpack_public_path__ + "static/media/car.fce352c3.svg";